export const DOCK_BAR_HEIGHT_REM = 4
export const DOCK_MARGIN_BOTTOM_REM = 1
export const CONTAINER_ICON_WIDTH = 64
export const CONTAINER_ICON_HEIGHT = 56
export const ICON_SIZE = 24
export const DOCK_PADDING = 8
export const MIN_SCALE = 1
export const LERP_ACTIVE = 0.2
export const LERP_IDLE = 0.12
export const SCALE_THRESHOLD = 0.002
export const POSITION_THRESHOLD = 0.1

export const ACTIVE_GRADIENT =
  "linear-gradient(51.15deg, #FA8731 0%, #EB5B00 99.94%)"

export interface DockResponsiveConfig {
  maxScale: number
  effectWidth: number
}

export function getResponsiveConfig(): DockResponsiveConfig {
  if (typeof window === "undefined") {
    return { maxScale: 1.5, effectWidth: 200 }
  }
  const w = window.innerWidth
  if (w < 380) {
    return { maxScale: 1.35, effectWidth: w * 0.45 }
  }
  if (w < 768) {
    return { maxScale: 1.5, effectWidth: w * 0.38 }
  }
  return { maxScale: 1.6, effectWidth: 280 }
}

/** Spacer so content isn't covered when scrolled to end. */
export const DOCK_SPACER_HEIGHT_REM =
  DOCK_BAR_HEIGHT_REM + DOCK_MARGIN_BOTTOM_REM
